"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDropdownVariant = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _button = _interopRequireDefault(require("@ux/button"));
var _reactMintl = require("@godaddy/react-mintl");
var _react = _interopRequireDefault(require("react"));
var _SearchComparisonCard = require("./SearchComparisonCard");
var _sparklesFilled = _interopRequireDefault(require("@ux/icon/sparkles-filled"));
const getDropdownVariant = ({
  variant,
  bodyText,
  buttonText,
  onClick,
  cardConfigs = []
}) => {
  switch (variant) {
    case 'ai-widget':
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-cy": "ai-widget-container",
        "data-testid": "ai-widget-container",
        className: "ai-widget-container dropdown-content-block"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "ai-widget-body-text"
      }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: bodyText || 'customSuggestionsDropdown.aiWidget.body'
      })), /*#__PURE__*/_react.default.createElement(_button.default, {
        "data-cy": "dropdown-box-content-open-ai-modal",
        "data-testid": "dropdown-box-content-open-ai-modal",
        design: "secondary",
        size: "medium",
        className: "ai-widget-button font-weight-bold w-100",
        href: "#",
        icon: /*#__PURE__*/_react.default.createElement(_sparklesFilled.default, {
          height: "24",
          width: "24"
        }),
        text: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
          id: buttonText || 'customSuggestionsDropdown.aiWidget.button'
        }),
        ariaLabel: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
          id: buttonText || 'customSuggestionsDropdown.aiWidget.button'
        }),
        onClick: onClick
      }));
    case 'search-comparison':
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-cy": "search-comparison-cards-container",
        "data-testid": "search-comparison-cards-container",
        className: "search-comparison-cards"
      }, cardConfigs.map(cardConfig => {
        return /*#__PURE__*/_react.default.createElement(_SearchComparisonCard.SearchComparisonCard, (0, _extends2.default)({
          key: cardConfig.title
        }, cardConfig));
      }));
    default:
      return null;
  }
};
exports.getDropdownVariant = getDropdownVariant;